// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.textField {
  width: 100%;
  padding-bottom: 20px !important;
}

.buttonField {
  width: 100%;
  padding: 20px !important;
}

.selectField {
  width: 10%;
  margin-bottom: 20px !important;
}

.rootContainer {
  display: flex;
}

.rootContainer > * {
  background-color: white;
  color: black;
  margin-right: 20px;
  font-size: 12px;
}

.labelText {
  font-size: 14px;
  padding-bottom: 20px;
  color: rgb(87, 84, 84);
}

.headerText {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 80px;
  color: rgb(87, 84, 84);
}

/* ── Stepper layout ── */
.bio-container {
  max-width: 680px;
  margin: 0 auto;
  padding: 24px 16px 40px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.bio-stepper {
  margin-bottom: 32px;
}

.bio-content {
  flex: 1 1;
}

.bio-step {
  display: flex;
  flex-direction: column;
  animation: bioFadeIn 0.25s ease;
}

@keyframes bioFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.bio-step-title {
  font-weight: 600 !important;
  margin-bottom: 20px !important;
  color: #333 !important;
}

/* Role chooser cards */
.bio-role-chooser {
  margin-bottom: 24px;
}

.bio-role-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.bio-role-btn {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  text-align: left;
}
.bio-role-btn:hover {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}
.bio-role-btn.active {
  border-color: #1976d2;
  background: #e3f2fd;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.bio-role-icon {
  font-size: 24px;
  margin-bottom: 4px;
}

.bio-role-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.bio-role-desc {
  font-size: 12px;
  color: #777;
}

/* Image section */
.bio-image-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  margin-bottom: 20px;
}

.bio-brand-preview {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #eee;
}

/* Address row */
.bio-address-row {
  display: flex;
  gap: 12px;
}
.bio-address-row .textField {
  flex: 1 1;
}
.bio-address-row .bio-field-sm {
  flex: 0.4 1;
}
.bio-address-row .bio-field-lg {
  flex: 1.6 1;
}

/* Nav buttons */
.bio-nav {
  display: flex;
  align-items: center;
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

/* Success message */
.bio-saved-msg {
  color: #2e7d32 !important;
  background: #e8f5e9;
  border-radius: 6px;
  padding: 10px 14px !important;
  margin-top: 12px !important;
  font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/bio/Biodetails.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,+BAAA;AAEJ;;AACA;EACI,WAAA;EACA,wBAAA;AAEJ;;AACA;EACI,UAAA;EACA,8BAAA;AAEJ;;AACA;EACI,aAAA;AAEJ;;AACA;EACI,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAEJ;;AACA;EACI,eAAA;EACA,oBAAA;EACA,sBAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AAEJ;;AACA,yBAAA;AACA;EACI,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,SAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,+BAAA;AAEJ;;AACA;EACI;IAAO,UAAA;IAAY,0BAAA;EAIrB;EAHE;IAAO,UAAA;IAAY,wBAAA;EAOrB;AACF;AALA;EACI,2BAAA;EACA,8BAAA;EACA,sBAAA;AAOJ;;AAJA,uBAAA;AACA;EACI,mBAAA;AAOJ;;AAJA;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAOJ;;AAJA;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8CAAA;EACA,gBAAA;AAOJ;AALI;EACI,qBAAA;EACA,8CAAA;AAOR;AAJI;EACI,qBAAA;EACA,mBAAA;EACA,6CAAA;AAMR;;AAFA;EACI,eAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAKJ;;AAFA;EACI,eAAA;EACA,WAAA;AAKJ;;AAFA,kBAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAKJ;;AAFA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAKJ;;AAFA,gBAAA;AACA;EACI,aAAA;EACA,SAAA;AAKJ;AAHI;EACI,SAAA;AAKR;AAFI;EACI,WAAA;AAIR;AADI;EACI,WAAA;AAGR;;AACA,gBAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAEJ;;AACA,oBAAA;AACA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;AAEJ","sourcesContent":[".textField {\n    width: 100%;\n    padding-bottom: 20px !important;\n}\n\n.buttonField {\n    width: 100%;\n    padding: 20px !important;\n}\n\n.selectField {\n    width: 10%;\n    margin-bottom: 20px !important;\n}\n\n.rootContainer {\n    display: flex;\n}\n\n.rootContainer > * {\n    background-color: white;\n    color: black;\n    margin-right: 20px;\n    font-size: 12px;\n}\n\n.labelText {\n    font-size: 14px;\n    padding-bottom: 20px;\n    color: rgb(87, 84, 84);\n}\n\n.headerText {\n    font-size: 20px;\n    font-weight: bold;\n    padding-bottom: 80px;\n    color: rgb(87, 84, 84);\n}\n\n/* ── Stepper layout ── */\n.bio-container {\n    max-width: 680px;\n    margin: 0 auto;\n    padding: 24px 16px 40px;\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n}\n\n.bio-stepper {\n    margin-bottom: 32px;\n}\n\n.bio-content {\n    flex: 1;\n}\n\n.bio-step {\n    display: flex;\n    flex-direction: column;\n    animation: bioFadeIn 0.25s ease;\n}\n\n@keyframes bioFadeIn {\n    from { opacity: 0; transform: translateY(8px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.bio-step-title {\n    font-weight: 600 !important;\n    margin-bottom: 20px !important;\n    color: #333 !important;\n}\n\n/* Role chooser cards */\n.bio-role-chooser {\n    margin-bottom: 24px;\n}\n\n.bio-role-buttons {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-top: 8px;\n}\n\n.bio-role-btn {\n    flex: 1;\n    min-width: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 16px;\n    border: 2px solid #ddd;\n    border-radius: 10px;\n    background: #fff;\n    cursor: pointer;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    text-align: left;\n\n    &:hover {\n        border-color: #1976d2;\n        box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);\n    }\n\n    &.active {\n        border-color: #1976d2;\n        background: #e3f2fd;\n        box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);\n    }\n}\n\n.bio-role-icon {\n    font-size: 24px;\n    margin-bottom: 4px;\n}\n\n.bio-role-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n}\n\n.bio-role-desc {\n    font-size: 12px;\n    color: #777;\n}\n\n/* Image section */\n.bio-image-section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px;\n    border: 1px dashed #ccc;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.bio-brand-preview {\n    width: 100px;\n    height: 100px;\n    object-fit: contain;\n    border-radius: 6px;\n    border: 1px solid #eee;\n}\n\n/* Address row */\n.bio-address-row {\n    display: flex;\n    gap: 12px;\n\n    .textField {\n        flex: 1;\n    }\n\n    .bio-field-sm {\n        flex: 0.4;\n    }\n\n    .bio-field-lg {\n        flex: 1.6;\n    }\n}\n\n/* Nav buttons */\n.bio-nav {\n    display: flex;\n    align-items: center;\n    margin-top: 32px;\n    padding-top: 16px;\n    border-top: 1px solid #eee;\n}\n\n/* Success message */\n.bio-saved-msg {\n    color: #2e7d32 !important;\n    background: #e8f5e9;\n    border-radius: 6px;\n    padding: 10px 14px !important;\n    margin-top: 12px !important;\n    font-weight: 500 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
